module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "list-item",
    on: {
      "click": function($event) {
        _vm.$emit('onClick')
      }
    }
  }, [_c('span', {
    staticClass: "label",
    style: ({
      backgroundImage: 'url(' + _vm.item.icon.url + ')',
      width: _vm.item.icon.size.width + 'px',
      height: _vm.item.icon.size.height + 'px',
      backgroundSize: _vm.item.icon.size.width + 'px ' + _vm.item.icon.size.height + 'px',
      marginTop: (_vm.item.icon.size.height * -.5) + 'px'
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "message",
    style: ({
      paddingLeft: (_vm.item.icon.size.width + 4) + 'px'
    })
  }, [_vm._v(_vm._s(_vm.item.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41f24dcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListItem.vue
// module id = 53
// module chunks = 0